import React, {useEffect, useState} from 'react';
import {withRouter, useParams} from 'react-router-dom';
import Loader from 'react-loader-spinner';
import notesApi from "../services/api/notes";
import Sidebar from "../components/Sidebar";
import Nav from "../components/nav/Nav";

const Share = () => {
    const {shareUrl} = useParams();
    const [videos, setVideos] = useState({});
    const [selectedVideo, setSelectedVideo] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const getShareNotes = async (shareUrl) => {
        const {data} = await notesApi.getShareNotes(shareUrl);
        if (data.length) {
            let video = {};
            video[data[0].videoId] = {
                name: data[0].videoTitle,
                notes: data
            };
            setSelectedVideo(data[0].videoId);
            setVideos(video);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        getShareNotes(shareUrl);
    }, [shareUrl]);

    return (!isLoading) ? (
        <>
            <nav className='share-nav'>
                <Nav />
            </nav>
            <div className='share-main'>
                <Sidebar selectedVideo={selectedVideo} videos={videos} />
            </div>
        </>
    ) : (
        <div className='loader-container'>
            <Loader
                type="ThreeDots"
                color="#8c9fa8"
                height={50}
                width={50}
            />
        </div>
    );
};

export default withRouter(Share);
